/**
 * Intersection Observer
 * Companent for multiple sections animations
 * */
document
  .querySelectorAll("[data-intersection-observer]")
  .forEach((intersectElement, i) => {
    const intersectionID = intersectElement?.dataset?.id;
    if (!intersectionID) return;

    const observerElement = document.querySelector(
      `[data-id="${intersectionID}"]`
    );
    if (!observerElement) return;

    const intersectOnce =
      observerElement.dataset.intersectOnce === undefined
        ? true
        : observerElement.dataset.intersectOnce !== "false";

    let parsedObserverOptions = {};
    try {
      parsedObserverOptions =
        JSON.parse(observerElement.dataset.intersectionObserver || "{}") || {};
    } catch (e) {
      parsedObserverOptions = {};
    }

    const observerOptions = {
      rootMargin: "0px 0px -50% 0px",
      threshold: 0,
      ...parsedObserverOptions
    };

    const animationBody = observerElement.querySelector(
      ".full-width-banner__animation--body"
    );
    const animationElements = observerElement.querySelectorAll(
      ".full-width-banner__animation"
    );
    if (!animationBody || !animationElements.length) return;

    const intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (!entry.target || intersectionID !== entry.target.dataset.id) {
            return;
          }
          // console.log("intersectionObserver", observerElement.dataset.id);

          /** check if already animated */
          if (
            observerElement.classList.contains("isAnimated") &&
            intersectOnce
          ) {
            return;
          }

          observerElement.classList.remove("inAnimation");

          let animationDelay =
            Number(animationBody.dataset.animationDelay) || 300;
          let animationDuration =
            Number(animationBody.dataset.animationDuration) || 900;

          setAnimation({
            observerElement,
            animationBody,
            animationElements
          });

          setTimeout(() => {
            if (
              observerElement.classList.contains("isAnimated") &&
              intersectOnce
            ) {
              intersectionObserver.unobserve(observerElement);
            } else if (
              observerElement.classList.contains("isAnimated") &&
              !intersectOnce
            ) {
              observerElement.classList.remove("isAnimated");
            }
          }, animationElements.length * (animationDelay + animationDuration) + animationDelay);
        }
      });
    }, observerOptions);

    intersectionObserver.observe(observerElement);

    function setAnimation(params) {
      const { observerElement, animationBody, animationElements } =
        params;

      let animationDelay =
        Number(animationBody.dataset.animationDelay) || 300;
      let animationDuration =
        Number(animationBody.dataset.animationDuration) || 900;

      animationElements.forEach((element, i) => {
        i++;
        animationDelay =
          Number(element.dataset.animationDelay) || animationDelay;
        animationDuration =
          Number(element.dataset.animationDuration) || animationDuration;
        setTimeout(() => {
          const animatedNode = element.querySelector("*");
          if (!animatedNode) return;
          element.classList.add("inAnimation");
          animatedNode.style.animationDuration = `${animationDuration}ms`;
        }, i * animationDelay);

        setTimeout(() => {
          const animatedNode = element.querySelector("*");
          if (!animatedNode) return;
          animatedNode.style.animationDuration = "";
          if (animatedNode.style.length === 0) {
            animatedNode.removeAttribute("style");
          }
          element.classList.remove("inAnimation");
          element.classList.add("isAnimated");
          if (i === animationElements.length) {
            observerElement.classList.remove("inAnimation");
            observerElement.classList.add("isAnimated");
          }
        }, i * (animationDelay + animationDuration));
      });
    }
  });
